import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { Comment } from 'src/app/models/comment.model';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LookupService } from 'src/app/services/lookup.service';

import moment from 'moment';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { FollowUpService } from 'src/app/services/sections/job/follow-up.service';


@Component({
	templateUrl: './follow-up-details.component.html',
	styleUrls: ['./follow-up-details.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss']
})
export class FollowUpDetailsComponent implements OnInit, OnDestroy, AfterViewInit {

	public followUp: Comment;
	public followUpTypesMap = new Map<number, string>();
	public self = this;
	public moment = moment;
	public isLoading = false;

	public readonly PageType = PageType;
	public readonly ButtonIcons = ButtonIcons;

	public unsubscriber$ = new Subject<void>();

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private followUpService: FollowUpService,
		private lookupService: LookupService
	) { }

	public ngOnInit(): void {

		this.followUp = (this.route.snapshot.data.followUp || {}) as Comment;

		this.lookupService.getJobFollowUpTypes()
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe((types) => {
				types.forEach(item => this.followUpTypesMap.set(item.id, item.name));
				GlobalSettingsService.isSecondaryLoaderLoading = false;
			});
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}

	public navigateWithData(subpage: string): void {
		this.router.navigate([subpage], { relativeTo: this.route, state: { followUp: this.followUp } });
	}

	public closeFollowUp(): void {
		if (this.followUp?.jobFollowUpId) {
			this.followUpService.completeJobFollowUp(TokenHelper.getToken(this.route))
				.subscribe(
					() => {
						this.followUpService.getJobFollowUp(TokenHelper.getToken(this.route))
							.subscribe((result: Comment) => this.followUp = result);
						GlobalSettingsService.isSecondaryLoaderLoading = false;
					},
					() => {
						GlobalSettingsService.isSecondaryLoaderLoading = false;
					}
				);
		}
	}
}
